import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class BannerItem extends Component {
  render () {
    return (<button className='re_banner_btn' type='button' onClick={this.props.goBanner}>
      <span className='re_banner_dot'>
        <i className='ir'>배너</i>
      </span>
            </button>);
  }
}

export default BannerItem;
